(function () {
  'use strict';
  if (window.plungeEmptyCartInitialized) return;
  window.plungeEmptyCartInitialized = true;
  // Same staffed-hours snapshot as the active sales-contact experiment, Oct 20 2026.
  const clock = new Intl.DateTimeFormat('en-US', {timeZone:'America/Los_Angeles',weekday:'short',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
  function online(date) {
    const p = Object.fromEntries(clock.formatToParts(date).map(x=>[x.type,x.value]));
    const minute = Number(p.hour)*60+Number(p.minute);
    const start = ['Sat','Sun'].includes(p.weekday)?9:6;
    const end = ['Tue','Wed'].includes(p.weekday)?17:18;
    return minute>=start*60 && minute<end*60;
  }
  function render() {
    document.querySelectorAll('[data-pec]').forEach(card=>{
      const override = card.dataset.pecPreview==='true' ? new URL(location.href).searchParams.get('pec-state') : null;
      const isOnline = override==='online' ? true : override==='offline' ? false : online(new Date());
      const state = isOnline?'online':'offline';
      if (card.dataset.state===state) return;
      card.dataset.state=state;
      const status=card.querySelector('[data-pec-status]');
      status.dataset.online=String(isOnline);
      status.textContent=isOnline?'Online now · Call or text us':'After hours · Schedule a call or email us';
      const primary=card.querySelector('[data-pec-primary]');
      primary.href=isOnline?'tel:+18888600572':'/pages/schedule-a-call?source=EmptyCart';
      primary.textContent=isOnline?'Call Now':'Schedule a Call';
      primary.dataset.pecAction=isOnline?'call':'schedule';
      const secondary=card.querySelector('[data-pec-secondary]');
      secondary.href=isOnline?'sms:+18888600572':'mailto:sales@plunge.com';
      secondary.textContent=isOnline?'Text Now':'Email Us';
      secondary.dataset.pecAction=isOnline?'text':'email';
    });
  }
  document.addEventListener('click',event=>{
    const target=event.target.closest('[data-pec-action]');
    if(!target||!target.closest('[data-pec]'))return;
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({event:'plunge_empty_cart_click',action:target.dataset.pecAction,availability:target.closest('[data-pec]').dataset.state||'unknown'});
  });
  function start(){render();setInterval(render,30000);new MutationObserver(render).observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
